import listActions from 'src/modules/departamento/list/departamentoListActions';
import DepartamentoService from 'src/modules/departamento/departamentoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'DEPARTAMENTO_DESTROY';

const departamentoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: departamentoDestroyActions.DESTROY_STARTED,
      });

      await DepartamentoService.destroyAll([id]);

      dispatch({
        type: departamentoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.departamento.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/departamento');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: departamentoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: departamentoDestroyActions.DESTROY_ALL_STARTED,
      });

      await DepartamentoService.destroyAll(ids);

      dispatch({
        type: departamentoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.departamento.destroyAll.success'),
      );

      getHistory().push('/departamento');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: departamentoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default departamentoDestroyActions;
